import React from 'react';

export const SpilledFlowers = () => (
  <svg
    width="174"
    height="167"
    viewBox="0 0 174 167"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M101.902 120.458C100.925 129.251 91.0109 141.014 77.2944 137.875C66.4355 135.391 67.8504 125.289 58.2096 123.013C48.5687 120.736 33.8705 137.028 24.0259 123.119C14.1812 109.211 33.8077 104.419 32.8304 95.4753C31.853 86.5316 23.5948 81.6708 29.5857 70.4715C35.5767 59.2721 53.119 66.6618 62.2711 64.4663C71.4232 62.2708 80.5474 54.7421 91.8347 63.8826C103.122 73.023 100.22 86.3181 96.0127 96.2553C91.805 106.193 103.065 110 101.902 120.458Z"
      fill="#E8EEF4"
    />
    <mask
      id="mask0_748_143156"
      style={{ 'mask-type': 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="44"
      y="0"
      width="45"
      height="70"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.3369 1.71833e-05C57.6694 0.0204785 50.2101 5.18307 46.8479 12.5987C45.3481 16.3154 44.3229 20.7822 44.3229 25.9715C44.3229 40.4672 52.3223 51.1376 56.322 54.6609L52.7142 69.6161L66.6995 69.6161L80.0634 69.6161L76.7888 54.6609C80.6774 51.1376 88.4546 40.4672 88.4546 25.9715C88.4546 21.4121 87.6852 17.4104 86.5094 13.9852L86.5 13.9852C83.4759 5.8344 75.6384 0.0217313 66.4403 1.71924e-05L66.3369 1.71833e-05Z"
        fill="#C4C4C4"
      />
    </mask>
    <g mask="url(#mask0_748_143156)">
      <path
        d="M52.7142 69.6157L66.6996 69.6157L66.6996 -0.000387143L56.322 -0.00038805C52.3223 2.61689 44.323 11.4754 44.323 25.9711C44.323 40.4668 52.3223 51.1372 56.322 54.6605L52.7142 69.6157Z"
        fill="#4585D3"
      />
      <path
        d="M80.0634 69.6157L66.6996 69.6157L66.6996 -0.000387143L76.7889 -0.000386261C80.6774 2.61689 88.4546 11.4754 88.4546 25.9711C88.4546 40.4668 80.6774 51.1372 76.7889 54.6605L80.0634 69.6157Z"
        fill="#204F88"
      />
      <path
        d="M46.0085 43.6937L49.504 32.7705L54.7471 35.829L58.6795 26.6535"
        stroke="#204F88"
        strokeWidth="3"
      />
    </g>
    <circle
      cx="13.9854"
      cy="13.9854"
      r="13.9854"
      transform="matrix(1 8.74228e-08 8.74228e-08 -1 52.4034 86.3981)"
      fill="#133053"
    />
    <circle
      cx="13.9854"
      cy="13.9854"
      r="13.9854"
      transform="matrix(1 8.74228e-08 8.74228e-08 -1 52.4034 86.3981)"
      fill="#133053"
    />
    <mask
      id="mask1_748_143156"
      style={{ 'mask-type': 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="53"
      y="58"
      width="66"
      height="71"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.0966 59.9193C61.4241 73.3329 69.5837 87.3951 73.2996 93.1997C74.109 96.4741 64.8246 106.212 57.9995 110.574C57.892 110.637 57.7852 110.702 57.6792 110.77C57.621 110.807 57.5634 110.844 57.5063 110.883L57.4171 110.937L57.4203 110.941C53.1425 113.862 51.9294 119.673 54.7337 124.073C57.5938 128.559 63.5497 129.878 68.0366 127.018C68.8679 126.488 69.5905 125.852 70.1979 125.138C73.4868 121.957 78.4178 113.409 79.5443 102.073C80.2008 102.857 80.8425 103.554 81.4388 104.101C84.2821 106.711 88.1092 109.555 89.6673 110.65L95.5968 103.185C95.3193 102.989 94.9733 102.755 94.5807 102.49L94.5806 102.49L94.5805 102.49C92.8994 101.353 90.3622 99.6364 88.6766 97.9187C97.973 100.783 106.376 100.273 110.792 98.9578C111.957 98.7354 113.1 98.2927 114.161 97.6164C118.648 94.7563 119.966 88.8004 117.106 84.3135C114.358 80.002 108.751 78.6159 104.336 81.0518L104.328 81.034C104.245 81.0896 104.161 81.1452 104.076 81.2008C103.984 81.2549 103.894 81.3106 103.803 81.3681C103.709 81.4282 103.616 81.4896 103.525 81.5524C96.3339 86.0379 83.0287 90.4063 81.2593 87.6305L81.2499 87.6338C81.1945 87.5417 81.1419 87.4532 81.0922 87.3684L80.8224 87.5529C77.0033 82.1942 69.8847 70.8207 68.2726 58.5531C67.6564 58.4701 67.0276 58.4273 66.3888 58.4273C64.1256 58.4273 61.9879 58.9649 60.0966 59.9193Z"
        fill="#C4C4C4"
      />
    </mask>
    <g mask="url(#mask1_748_143156)">
      <circle
        cx="9.63437"
        cy="9.63437"
        r="9.63437"
        transform="matrix(0.843249 -0.537524 -0.537524 -0.843249 106.037 102.796)"
        fill="#A1B6CA"
      />
      <circle
        cx="9.63437"
        cy="9.63437"
        r="9.63437"
        transform="matrix(0.843249 -0.537524 -0.537524 -0.843249 59.9124 132.197)"
        fill="#A1B6CA"
      />
      <path
        d="M75.1396 95.954L83.2638 90.7753L70.0389 45.4452L55.093 64.5056L75.1396 95.954Z"
        fill="#A1B6CA"
      />
      <path
        d="M79.4509 91.7315C81.4471 108.74 73.8568 122.079 69.7041 125.586L57.4171 110.937C64.5732 106.6 74.9727 95.6918 73.1351 92.809C75.7262 90.1593 79.4509 91.7315 79.4509 91.7315Z"
        fill="#A1B6CA"
      />
      <path
        d="M79.4509 91.7315C81.4471 108.74 73.8568 122.079 69.7041 125.586L57.4171 110.937C64.5732 106.6 74.9727 95.6918 73.1351 92.809C75.7262 90.1593 79.4509 91.7315 79.4509 91.7315Z"
        fill="#A1B6CA"
      />
      <path
        d="M77.6164 92.9016C92.192 101.891 107.489 100.641 112.421 98.3572L104.328 81.0344C97.376 85.6912 83.0969 90.5137 81.2593 87.631C77.7635 88.8613 77.6164 92.9016 77.6164 92.9016Z"
        fill="#A1B6CA"
      />
      <path
        d="M81.4387 104.101C78.5954 101.491 74.7182 95.4856 73.135 92.8093L80.9622 87.8272C82.3783 90.2415 86.2754 95.2686 88.2984 97.5172C90.3215 99.7658 94.0385 102.089 95.5967 103.185L89.6672 110.65C88.1091 109.555 84.282 106.712 81.4387 104.101Z"
        fill="#A1B6CA"
      />
    </g>
    <mask
      id="mask2_748_143156"
      style={{ 'mask-type': 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="53"
      y="58"
      width="66"
      height="71"
    >
      <mask
        id="mask3_748_143156"
        style={{ 'mask-type': 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="53"
        y="58"
        width="66"
        height="71"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.0965 59.9191C61.4238 73.3329 69.5836 87.3953 73.2995 93.1999C74.1089 96.4744 64.8245 106.212 57.9994 110.574C57.8919 110.637 57.7851 110.702 57.6791 110.77C57.6209 110.807 57.5633 110.845 57.5062 110.883L57.417 110.937L57.4202 110.941C53.1424 113.862 51.9293 119.673 54.7336 124.073C57.5938 128.56 63.5497 129.878 68.0365 127.018C68.8678 126.488 69.5904 125.852 70.1978 125.139C73.4867 121.957 78.4178 113.409 79.5442 102.073C80.2007 102.857 80.8424 103.554 81.4387 104.101C84.282 106.712 88.1091 109.555 89.6672 110.65L95.5967 103.185C95.3192 102.99 94.9732 102.756 94.5806 102.49L94.5805 102.49L94.5804 102.49C92.8993 101.353 90.3621 99.6366 88.6765 97.919C97.973 100.783 106.376 100.274 110.792 98.958C111.957 98.7356 113.1 98.293 114.161 97.6167C118.648 94.7565 119.966 88.8006 117.106 84.3138C114.358 80.0023 108.751 78.6161 104.336 81.0521L104.328 81.0342C104.245 81.0898 104.161 81.1454 104.075 81.2011C103.984 81.2551 103.894 81.3109 103.803 81.3683C103.709 81.4284 103.616 81.4898 103.525 81.5526C96.3338 86.0381 83.0286 90.4066 81.2592 87.6307L81.2498 87.634C81.1945 87.542 81.1418 87.4534 81.0921 87.3687L80.8223 87.5531C77.0031 82.1944 69.8845 70.8206 68.2724 58.5529C67.6563 58.47 67.0275 58.4271 66.3887 58.4271C64.1255 58.4271 61.9878 58.9647 60.0965 59.9191Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask3_748_143156)">
        <circle
          cx="9.63437"
          cy="9.63437"
          r="9.63437"
          transform="matrix(0.843249 -0.537524 -0.537524 -0.843249 106.037 102.796)"
          fill="#A1B6CA"
        />
        <circle
          cx="9.63437"
          cy="9.63437"
          r="9.63437"
          transform="matrix(0.843249 -0.537524 -0.537524 -0.843249 59.9121 132.197)"
          fill="#A1B6CA"
        />
        <path
          d="M75.1395 95.9544L83.2637 90.7757L70.0388 45.4456L55.0929 64.5059L75.1395 95.9544Z"
          fill="#A1B6CA"
        />
        <path
          d="M79.4508 91.7319C81.447 108.74 73.8567 122.08 69.7039 125.587L57.417 110.937C64.5731 106.601 74.9726 95.6922 73.135 92.8094C75.726 90.1597 79.4508 91.7319 79.4508 91.7319Z"
          fill="#A1B6CA"
        />
        <path
          d="M79.4508 91.7319C81.447 108.74 73.8567 122.08 69.7039 125.587L57.417 110.937C64.5731 106.601 74.9726 95.6922 73.135 92.8094C75.726 90.1597 79.4508 91.7319 79.4508 91.7319Z"
          fill="#A1B6CA"
        />
        <path
          d="M77.6163 92.902C92.1919 101.891 107.489 100.642 112.421 98.3575L104.328 81.0348C97.3759 85.6916 83.0968 90.5141 81.2592 87.6314C77.7634 88.8617 77.6163 92.902 77.6163 92.902Z"
          fill="#A1B6CA"
        />
        <path
          d="M81.4386 104.102C78.5953 101.491 74.7181 95.486 73.1349 92.8097L80.9621 87.8276C82.3782 90.2419 86.2753 95.269 88.2983 97.5176C90.3214 99.7662 94.0384 102.09 95.5966 103.185L89.6671 110.65C88.109 109.555 84.2819 106.712 81.4386 104.102Z"
          fill="#A1B6CA"
        />
      </g>
    </mask>
    <g mask="url(#mask2_748_143156)">
      <path
        d="M75.7189 88.7009C64.8831 74.3696 62.4654 52.7271 63.048 46.7557L101.498 35.3956L136.015 92.1963L103.246 117.975C98.5849 114.188 86.5547 103.032 75.7189 88.7009Z"
        fill="#718199"
      />
    </g>
    <circle
      cx="12.0934"
      cy="12.0934"
      r="12.0934"
      transform="matrix(0.679913 -0.733293 -0.733293 -0.679913 117.876 143.92)"
      fill="#EA580C"
    />
    <ellipse
      cx="12.4598"
      cy="12.0934"
      rx="12.4598"
      ry="12.0934"
      transform="matrix(0.679913 -0.733293 -0.733293 -0.679913 101.998 149.188)"
      fill="#EA580C"
    />
    <path
      d="M133.035 106.373L146.975 102.159L142.131 122.564L131.542 113.198C129.197 111.123 130.037 107.279 133.035 106.373Z"
      fill="#EA580C"
    />
    <ellipse
      cx="12.0934"
      cy="12.4598"
      rx="12.0934"
      ry="12.4598"
      transform="matrix(0.556448 0.830883 0.830883 -0.556448 133.584 110.577)"
      fill="#EA580C"
    />
    <circle
      cx="11.7269"
      cy="11.7269"
      r="11.7269"
      transform="matrix(0.679913 -0.733293 -0.733293 -0.679913 93.1636 135)"
      fill="#EA580C"
    />
    <circle
      cx="12.0934"
      cy="12.0934"
      r="12.0934"
      transform="matrix(0.679913 -0.733293 -0.733293 -0.679913 104.625 122.638)"
      fill="#EA580C"
    />
    <circle
      cx="5.13052"
      cy="5.13052"
      r="5.13052"
      transform="matrix(0.679913 -0.733293 -0.733293 -0.679913 106.853 126.704)"
      fill="#FACC15"
    />
  </svg>
);
